//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('equipmentGrpLang', {
//        templateUrl: 'views/components/views/equipmentGrpLang/equipmentGrpLang.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'translateService', 'modalService', 'equipmentGrpLangService', function ($stateParams, stateService, translateService, modalService, equipmentGrpLangService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let equipmentGrpId = $stateParams.equipmentgrp_id;

//            let translations = {
//                confirmation: '',
//                ok: ''
//            };

//            vm.model = {
//                inputListLanguages: [],
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATE SERVICE

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATE SERVICE

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadLanguages() {
//                vm.model.inputListLanguages = (await equipmentGrpLangService.listLanguages({ equipmentgrp_id: equipmentGrpId }));
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                equipmentGrpLangService.saveObj({ records: vm.model.inputListLanguages }).then(function (response) {
//                    if (response[0].ws_result === '1') {
//                    	modalService.show({
//                    		type: 'success',
//                    		title: translations.confirmation,
//                            message: response[0].ws_result_message,
//                    		buttons: [{
//                    			label: translations.ok,
//                    			cssClass: 'btn-success',
//                    			action: function (dialogItself) {
//                    				dialogItself.close();
//                                    vm.model.lockedSave = false;
//                                    stateService.back();
//                    			}
//                    		}]
//                    	});
//                    } else {
//                    	vm.model.lockedSave = false;
//                    }
//                });
//            };

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                translate();
//                loadLanguages();
//            };

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
